export default "/images/829cf41797fe78668a07ebac984e98e0.avif";